import styles from 'assets/jss/ProfileStyle';
import {useState} from 'react';
import {makeStyles} from '@mui/styles';
import {Button, Grid} from '@mui/material';
// ----------------componet--------------------
import logoutIcon from 'assets/img/logout.svg';
import ExitModal from 'components/Modal/ExitModal';
import EditScanCenterInfo from "components/EditAgentProfile/EditScanCenterInfo";
import ProfileSkeleton from "components/Loading/ProfileSkeleton";
import EditPersonalInfo from 'components/EditAgentProfile/EditPersonalInfo';

import {logoutHandler} from 'helpers/auth';
import useAgentInfo from "hooks/useAgentInfo";

const useStyles = makeStyles(styles);

const Profile = () => {
    const classes = useStyles();
    const {data, isLoading} = useAgentInfo();
    const [activeEdit, setActiveEdit] = useState({personal: false, scanCenter: false});

    return (
        <div style={{paddingBottom:'26px'}}>
            {isLoading ? <ProfileSkeleton /> :
                <div className={classes.profile__container}>
                    <Grid container>
                        <EditPersonalInfo activeEdit={activeEdit} setActiveEdit={setActiveEdit}/>
                        {data?.isScanCenter &&
                            <EditScanCenterInfo activeEdit={activeEdit} setActiveEdit={setActiveEdit}/>}
                    </Grid>
                    <Grid container className={classes.exitContainer}>
                        <ExitModal logout={logoutHandler}>
                            <Button className={classes.logout}>
                                <img src={logoutIcon} alt=''/>
                                <span className={classes.logoutText}>خروج</span>
                            </Button>
                        </ExitModal>
                    </Grid>
                </div>
            }
        </div>
    );
};

export default Profile;
